import React from 'react';
import { Skeleton as MUISkeleton } from '@mui/material';
import { range } from 'lodash';

interface Props {
	rows?: number;
	rowHeight?: number;
}
export const SkeletonList = ({ rows = 1, rowHeight = 50 }: Props) => {
	return (
		<>
			{range(rows).map((_, index) => (
				<MUISkeleton
					key={`skeleton_${index + 1}`}
					sx={{ my: 1 }}
					variant="rectangular"
					height={rowHeight}
				/>
			))}
		</>
	);
};

export default SkeletonList;
